module.exports = __webpack_public_path__ + "img/content-1.c2dbc394.png";